/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const plRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Wniosek o dodanie Szkoły',
    description: 'Prosimy o wypełnienie poniższego formularza. Złożenie wniosku nie gwarantuje, że szkoła zostanie dodana, ale wszystkie wnioski są sprawdzane i rozważane przez SheerID. ',
    noCountry: 'Nie widzisz kraju swojej szkoły? Nie możesz skorzystać z tej oferty',
    searchByOrgName: 'Nie widzisz swojej szkoły? Wyszukiwanie za pomocą nazwy',
    completeRequest: 'Nie widzisz swojej szkoły na liście kwalifikujących się ani niekwalifikujących się szkół? Zakończ wniosek',
    submit: 'Wyślij',
    eligibleOrgs: 'Kwalifikujące się szkoły. Kliknij na ikonę, aby skopiować nazwę, a następnie wróć do formularza weryfikującego.',
    ineligibleOrgs: 'Niekwalifikujące się szkoły. Przepraszamy, ale uczniowie tych szkół nie kwalifikują się do skorzystania z tej oferty',
    none: 'Brak',
    country: 'Gdzie chodzisz do szkoły?',
    changeLanguage: 'Zmień język',
    copied: 'Skopiowano',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    emailAddress: 'E-mail',
    poweredBy: 'Serwisy weryfikujące wspierane przez SheerID',
    fields: {
        countryPlaceholder: 'Wybierz kraj',
        domainLabel: 'Strona internetowa szkoły',
        domainPlaceholder: 'www.moja-szkola.pl',
        orgNameLabel: 'Nazwa szkoły',
        orgNamePlaceholder: 'Moja szkoła',
    },
    step: {
        success: {
            title: 'Dziękujemy za złożenie wniosku szkoły',
            description: 'Przypominamy, że każde żądanie jest oceniane przez SheerID pod kątem wymagań dotyczących tej oferty. Nie ma gwarancji, że dana szkoła zostanie dodana. Proces oceny trwa do 7 dni.',
        },
        error: {
            title: 'Wystąpił nieoczekiwany błąd',
            description: 'Przepraszamy, ale nie możemy przetworzyć twojego wniosku. Prosimy spróbować później.',
            seeingProblem: 'Jeśli ten problem będzie się powtarzał',
            contactUs: 'skontaktuj się z nami',
        },
    },
    errorId: {
        invalidCountry: 'Wymagane pole',
        invalidEmail: 'Nieprawidłowy e-mail',
        invalidFirstName: 'Nieprawidłowe imię',
        invalidLastName: 'Nieprawidłowe nazwisko',
        requiredField: 'Wymagane pole',
        invalidField: 'Nieprawidłowe pole',
        invalidUrl: 'Nieprawidłowy URL',
        tooManyResults: 'Wyszukiwanie zwróciło zbyt wiele wyników, prosimy uściślić zapytanie i spróbować ponownie',
    },
    faq: 'Dodawanie wniosku szkoły SheerID - FAQ',
    countries: {
        AD: 'Andora',
        AE: 'Zjednoczone Emiraty Arabskie',
        AF: 'Afganistan',
        AG: 'Antigua i Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Antyle Holenderskie',
        AO: 'Angola',
        AR: 'Argentyna',
        AS: 'Samoa Amerykańskie',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbejdżan',
        BA: 'Bośnia i Hercegowina',
        BB: 'Barbados',
        BD: 'Bangladesz',
        BE: 'Belgia',
        BF: 'Burkina Faso',
        BG: 'Bułgaria',
        BH: 'Bahrajn',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermudy',
        BN: 'Brunei Darussalam',
        BO: 'Boliwia',
        BR: 'Brazylia',
        BS: 'Bahamy',
        BT: 'Bhutan',
        BV: 'Wyspa Bouveta',
        BW: 'Botswana',
        BY: 'Białoruś',
        BZ: 'Belize',
        CA: 'Kanada',
        CD: 'Demokratyczna Republika Konga',
        CF: 'Republika Środkowoafrykańska',
        CG: 'Kongo',
        CH: 'Szwajcaria',
        CI: 'Wybrzeże Kości Słoniowej',
        CK: 'Wyspy Cooka',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Chiny',
        CO: 'Kolumbia',
        CR: 'Kostaryka',
        CU: 'Kuba',
        CV: 'Wyspy Zielonego Przylądka',
        CY: 'Cypr',
        CZ: 'Republika Czeska',
        DE: 'Niemcy',
        DJ: 'Dżibuti',
        DK: 'Dania',
        DM: 'Dominika',
        DO: 'Republika Dominikany',
        DZ: 'Algieria',
        EC: 'Ekwador',
        EE: 'Estonia',
        EG: 'Egipt',
        EH: 'Sahara Zachodnia',
        ER: 'Erytrea',
        ES: 'Hiszpania',
        ET: 'Etiopia',
        FI: 'Finlandia',
        FJ: 'Fidżi',
        FK: 'Falklandy',
        FM: 'Mikronezja',
        FO: 'Wyspy Owcze',
        FR: 'Francja',
        GA: 'Gabon',
        GB: 'Zjednoczone Królestwo',
        GD: 'Grenada',
        GE: 'Gruzja',
        GF: 'Gujana Francuska',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grenlandia',
        GM: 'Gambia',
        GN: 'Gwinea',
        GP: 'Gwadelupa (francuski)',
        GQ: 'Gwinea Równikowa',
        GR: 'Grecja',
        GS: 'Wyspy Georgia Południowa i Sandwich Południowy',
        GT: 'Gwatemala',
        GU: 'Guam (USA)',
        GW: 'Gwinea Bissau',
        GY: 'Gujana',
        HK: 'Hongkong',
        HM: 'Wyspy Heard i McDonalda',
        HN: 'Honduras',
        HR: 'Chorwacja',
        HT: 'Haiti',
        HU: 'Węgry',
        ID: 'Indonezja',
        IE: 'Irlandia',
        IL: 'Izrael',
        IN: 'Indie',
        IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Islandia',
        IT: 'Włochy',
        JM: 'Jamajka',
        JO: 'Jordania',
        JP: 'Japonia',
        KE: 'Kenia',
        KG: 'Kirgistan',
        KH: 'Kambodża',
        KI: 'Kiribati',
        KM: 'Komory',
        KN: 'Saint Kitts i Nevis Anguilla',
        KP: 'Korea Północna',
        KR: 'Korea Południowa',
        KW: 'Kuwejt',
        KY: 'Kajmany',
        KZ: 'Kazachstan',
        LA: 'Laos',
        LB: 'Liban',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litwa',
        LU: 'Luksemburg',
        LV: 'Łotwa',
        LY: 'Libia',
        MA: 'Maroko',
        MC: 'Monako',
        MD: 'Mołdawia',
        ME: 'Czarnogóra',
        MG: 'Madagaskar',
        MH: 'Wyspy Marshalla',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Mjanma (Birma)',
        MN: 'Mongolia',
        MO: 'Makau',
        MP: 'Mariany Północne',
        MQ: 'Martynika (francuski)',
        MR: 'Mauretania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediwy',
        MW: 'Malawi',
        MX: 'Meksyk',
        MY: 'Malezja',
        MZ: 'Mozambik',
        NA: 'Namibia',
        NC: 'Nowa Kaledonia (francuski)',
        NE: 'Niger',
        NF: 'Wyspa Norfolk',
        NG: 'Nigeria',
        NI: 'Nikaragua',
        NL: 'Niderlandy',
        NO: 'Norwegia',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nowa Zelandia',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polinezja (francuski)',
        PG: 'Papua Nowa Gwinea',
        PH: 'Filipiny',
        PK: 'Pakistan',
        PL: 'Polska',
        PM: 'Saint Pierre i Miquelon',
        PN: 'Wyspa Pitcairn',
        PR: 'Portoryko',
        PS: 'Palestyna',
        PT: 'Portugalia',
        PW: 'Palau',
        PY: 'Paragwaj',
        QA: 'Katar',
        RE: 'Reunion (francuski)',
        RO: 'Rumunia',
        RS: 'Serbia',
        RU: 'Federacja Rosyjska',
        RW: 'Rwanda',
        SA: 'Arabia Saudyjska',
        SB: 'Wyspy Salomona',
        SC: 'Seszele',
        SD: 'Sudan',
        SE: 'Szwecja',
        SG: 'Singapur',
        SH: 'Wyspa Świętej Heleny',
        SI: 'Słowenia',
        SK: 'Republika Słowacji',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        SS: 'Południowy Sudan',
        ST: 'Wyspy Świętego Tomasza i Książęca',
        SV: 'Salwador',
        SY: 'Syria',
        SZ: 'Suazi (Eswatini)',
        TC: 'Wyspy Turks i Caicos',
        TD: 'Czad',
        TF: 'Francuskie Terytoria Południowe',
        TG: 'Togo',
        TH: 'Tajlandia',
        TJ: 'Tadżykistan',
        TK: 'Tokelau',
        TL: 'Timor Wschodni',
        TM: 'Turkmenistan',
        TN: 'Tunezja',
        TO: 'Tonga',
        TR: 'Turcja',
        TT: 'Trynidad i Tobago',
        TV: 'Tuvalu',
        TW: 'Tajwan',
        TZ: 'Tanzania',
        UA: 'Ukraina',
        UG: 'Uganda',
        UM: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
        US: 'Stany Zjednoczone',
        UY: 'Urugwaj',
        UZ: 'Uzbekistan',
        VA: 'Watykan',
        VC: 'Saint Vincent i Grenadyny',
        VE: 'Wenezuela',
        VG: 'Wyspy Dziewicze (Brytyjskie)',
        VI: 'Wyspy Dziewicze (USA)',
        VN: 'Wietnam',
        VU: 'Vanuatu',
        WF: 'Wyspy Wallis i Futuna',
        WS: 'Samoa',
        XK: 'Kosowo',
        YE: 'Jemen',
        YT: 'Majotta',
        ZA: 'Afryka Południowa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'arabski',
        bg: 'bułgarski',
        cs: 'czeski',
        da: 'duński',
        de: 'niemiecki',
        el: 'grecki',
        'en-GB': 'angielski (Wlk. Brytania)',
        'en-US': 'angielski',
        'es-ES': 'hiszpański (Hiszpania)',
        es: 'hiszpański',
        fi: 'fiński',
        'fr-CA': 'francuski (kanadyjski)',
        fr: 'francuski',
        hr: 'chorwacki',
        hu: 'węgierski',
        id: 'indonezyjski',
        is: 'islandzki',
        it: 'włoski',
        iw: 'hebrajski',
        ja: 'japoński',
        ko: 'koreański',
        lt: 'litewski',
        ms: 'malajski',
        nl: 'niderlandzki',
        no: 'norweski',
        pl: 'polski',
        'pt-BR': 'portugalski (Brazylia)',
        pt: 'portugalski',
        ro: 'rumuński',
        ru: 'Rosja',
        sk: 'słowacki',
        sl: 'słoweński',
        sr: 'serbski',
        sv: 'szwedzki',
        tr: 'turecki',
        'zh-HK': 'chiński (Hongkong)',
        zh: 'chiński (tradycyjny)',
    },
};
